import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import api, { API_URL, APPNAME, AuthContext } from "./util/api";

export default function Navbar() {
  const { token, User, logout, Doctor, Patient } = useContext(AuthContext);

  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [dashboardLink, setDashboardLink] = useState("/select-role");
  const [profileLink, setProfileLink] = useState("/select-role");
  const [messageLink, setMessageLink] = useState("");
  const [noticount, setNotification] = useState(0);
  const [messageCount, setMessageCount] = useState(0);

  const isAuthenticated = Boolean(token && User);

  const [avatar, setAvatar] = useState("https://ui-avatars.com/api/?name=User&background=2563eb&color=fff");


  const fetchNotificationCount = async () => {
    const res = await api.get(`${API_URL}/notification_count`);
    if (res.status === 200 && res.data.status === "successful") {
      setNotification(res.data.notification_count);
      setMessageCount(res.data.chat_count);
    }
  };

  useEffect(() => {
    if (!User) return;
    fetchNotificationCount();
    const t = setInterval(fetchNotificationCount, 600000);
    return () => clearInterval(t);
  }, [User]);

  useEffect(() => {
    if (!User) return;

    if (User.role === "doctor") {
      setAvatar(
        Doctor?.profilePicture ||

        "https://ui-avatars.com/api/?name=User&background=2563eb&color=fff"
      );
      setDashboardLink("/lawyer-dashboard");
      setProfileLink("/lawyer-profile-reg");
      setMessageLink("/lawyer-active-cases");
    }

    if (User.role === "patient") {
      setAvatar(
        Patient?.profilePicture ||
        "https://ui-avatars.com/api/?name=User&background=2563eb&color=fff"
      );
      setDashboardLink("/client-dashboard");
      setProfileLink("/client-reg");
      setMessageLink("/client-ongoing-cases");
    }
  }, [User]);

  const logoutf = () => {
    logout();
    setProfileOpen(false);
    setMenuOpen(false);
  };

  return (
    <>
      <header className="nav-wrap">
        <div className="nav-inner">

          {/* LOGO */}
          <Link to="/" className="logo">

            <img
              src="/logo.png"
              alt={`${APPNAME} logo`}
              style={{ height: 32, marginLeft: 8, verticalAlign: "middle" }}
            />
          </Link>

          {/* NAV LINKS */}
          <nav className="nav-links">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/lawyers">Lawyers</NavLink>
            <NavLink to="/about-us">About</NavLink>

            {isAuthenticated && (
              <>
                   {/* <NavLink to={dashboardLink}>Post A case</NavLink> */}
                <NavLink to={dashboardLink}>Dashboard</NavLink>
                <NavLink to="/payment_details">Payments</NavLink>
              </>
            )}
          </nav>

          {/* RIGHT ACTIONS */}
          <div className="actions">

            {/* NOTIFICATIONS */}
            {isAuthenticated && (
              <>
                <Link to={messageLink} className="icon">
                  💬 {messageCount > 0 && <span>{messageCount}</span>}
                </Link>

                <Link to="/notifications" className="icon">
                  🔔 {noticount > 0 && <span>{noticount}</span>}
                </Link>
              </>
            )}

            {/* AUTH OR PROFILE */}
            {!isAuthenticated ? (
              <div className="auth">
                <Link to="/login">Login</Link>
                <Link to="/register" className="btn">Register</Link>
              </div>
            ) : (
              <div className="profile">

                <img
                  src={avatar}
                  alt="user"
                  onClick={() => setProfileOpen(!profileOpen)}
                />

                {profileOpen && (
                  <div className="dropdown">
                    {User?.role === "doctor" && (
                      <Link to={`/lawyer-profile/${Doctor?.id}`}>
                        View Profile
                      </Link>
                    )}

                    <Link to={profileLink}>Edit Profile</Link>
                    <button style={{ color: "#f80404ff" }} onClick={logoutf}>Logout</button>
                  </div>
                )}
              </div>
            )}

            {/* MOBILE MENU BUTTON */}
            <button
              className="menu-btn"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>

        {/* MOBILE MENU */}
        {menuOpen && (
          <div className="mobile">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/lawyers">Lawyers</NavLink>
            <NavLink to="/about-us">About</NavLink>

            {isAuthenticated ? (
              <>
                <NavLink to={dashboardLink}>Dashboard</NavLink>
                {/*  <NavLink to={dashboardLink}>Post A case</NavLink> */}
                <NavLink to="/payment_details">Payments</NavLink>
              </>
            ) : (
              <>
                <NavLink to="/login">Login</NavLink>
                <NavLink to="/register">Register</NavLink>
              </>
            )}
          </div>
        )}
      </header>

      {/* STYLES */}
      <style>{`
.nav-wrap {
  position: sticky;
  top: 0;
  z-index: 999;
  backdrop-filter: blur(20px);
  background: rgba(255,255,255,0.8);
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.nav-inner {
  max-width: 1200px;
  margin: auto;
  padding: 14px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* LOGO */
.logo {
  font-size: 22px;
  font-weight: 800;
  text-decoration: none;
  background: linear-gradient(120deg,#2563eb,#7c3aed,#2563eb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* NAV */
.nav-links {
  display: flex;
  gap: 24px;
}

.nav-links a {
  text-decoration: none;
  color: #374151;
  font-weight: 500;
  position: relative;
}

.nav-links a.active {
  color: #2563eb;
}

.nav-links a.active::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #2563eb;
  border-radius: 10px;
}

/* ACTIONS */
.actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* ICONS */
.icon {
  position: relative;
  font-size: 18px;
  text-decoration: none;
}

.icon span {
  position: absolute;
  top: -6px;
  right: -10px;
  background: red;
  color: white;
  font-size: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* AUTH */
.auth {
  display: flex;
  gap: 10px;
}

.auth a {
  text-decoration: none;
  font-weight: 500;
}

.btn {
  background: #2563eb;
  color: white;
  padding: 6px 12px;
  border-radius: 18px;
}

/* PROFILE */
.profile img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #2563eb;
}

.profile {
  position: relative;
}

.dropdown {
  position: absolute;
  right: 0;
  top: 50px;
  background: white;
  width: 180px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  overflow: hidden;
}

.dropdown a,
.dropdown button {
  display: block;
  width: 100%;
  padding: 10px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.dropdown a:hover,
.dropdown button:hover {
  background: #f3f4f6;
}

/* MOBILE */
.menu-btn {
  display: none;
  font-size: 22px;
 
  border: none;
  cursor: pointer;
  color: #f9fbfdff;
  background-color: #2563eb;
}

.mobile {
  display: none;
  flex-direction: column;
  padding: 14px;
  background: white;
  border-top: 1px solid #eee;
}

.mobile a {
  padding: 10px;
  text-decoration: none;
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .nav-links { display: none; }
  .menu-btn { display: block; }
  .mobile { display: flex; }
}
`}</style>
    </>
  );
}